var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogoVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_vertical",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 205.409,
    height: 179.782,
    viewBox: "0 0 205.409 179.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 205.409,
    height: 179.782,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M260.594,97.124l-27.812,39.463h53.369Z",
    transform: "translate(-80.743 -34.258)",
    fill: "#45783c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M284.64,136.313H232.262a.98.98,0,0,1-.8-1.544l27.3-38.731a.929.929,0,0,1,.82-.415.981.981,0,0,1,.8.447L285.462,134.8a.979.979,0,0,1-.822,1.512m-50.489-1.96h48.688l-23.316-36Z",
    transform: "translate(-80.21 -33.162)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 12.172,
    height: 10.162,
    transform: "translate(172.154 102.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M275.21,167.294H263.038a.98.98,0,0,1-.98-.98V156.153a.98.98,0,0,1,.98-.98H275.21a.979.979,0,0,1,.98.98v10.162a.98.98,0,0,1-.98.98m-11.192-1.96H274.23v-8.2H264.018Z",
    transform: "translate(-90.884 -53.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M246.6,83.993s-5.963-6.086-22.87-6.455c-14.754,0-25.636,14.2-25.636,34.673,0,16.107,7.992,31.476,26.066,32.644,15.677,0,20.041-3.689,24.56-6.086,2.582-2.152,6.179,6.024,2,10.2-11.466,7.677-64.243,19.857-66.641-36.026,0-40.205,33.812-58.894,66.856-38.361,3.6,2.951-1.291,11.711-4.334,9.406",
    transform: "translate(-63.839 -22.95)",
    fill: "#ece452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M222.977,156.139a43.528,43.528,0,0,1-19.708-4.32c-12.889-6.531-19.851-19.773-20.691-39.361,0-19.642,7.944-35.3,21.8-43,13.582-7.551,30.55-6.178,46.553,3.766a.839.839,0,0,1,.1.074c2.786,2.286,1.536,6.969-.438,9.471-1.628,2.063-3.585,2.627-5.109,1.473a.939.939,0,0,1-.105-.092c-.063-.063-5.991-5.811-22.194-6.164-14.265,0-24.635,14.17-24.635,33.694,0,13.858,6.586,30.466,25.149,31.666,13.473,0,18.408-2.8,22.374-5.05.538-.305,1.06-.6,1.583-.88a2.534,2.534,0,0,1,3.564.56c2.058,2.252,2.974,7.853-.333,11.16a1.017,1.017,0,0,1-.148.122c-4.32,2.892-15.567,6.883-27.766,6.884m.3-89.538a36.6,36.6,0,0,0-17.944,4.567c-13.214,7.346-20.792,22.38-20.792,41.247.807,18.786,7.408,31.469,19.618,37.656,16.9,8.561,38.932,1.884,45.416-2.39,2.51-2.6,1.572-6.892.206-8.386-.569-.624-.817-.417-.95-.306a1.034,1.034,0,0,1-.168.113c-.534.283-1.067.585-1.616.9-4.165,2.363-9.35,5.3-23.4,5.3-19.979-1.289-27.046-18.918-27.046-33.624,0-20.659,11.193-35.653,26.616-35.653,16.391.358,22.761,5.972,23.5,6.684.894.6,2.107-.852,2.346-1.154,1.456-1.846,2.44-5.267.779-6.706C241,69.372,231.884,66.6,223.273,66.6",
    transform: "translate(-63.319 -22.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M241.576,78.144a.981.981,0,0,1-.959-.782l-2.4-11.619a.98.98,0,1,1,1.92-.4l2.4,11.619a.981.981,0,0,1-.762,1.158.991.991,0,0,1-.2.02",
    transform: "translate(-82.609 -22.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M228.629,80.99a.979.979,0,0,1-.886-.56l-4.98-10.512a.98.98,0,1,1,1.771-.839l4.979,10.512a.98.98,0,0,1-.884,1.4",
    transform: "translate(-77.223 -23.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M215.585,87.887a.977.977,0,0,1-.751-.349l-7.746-9.222a.98.98,0,0,1,1.5-1.261l7.746,9.222a.98.98,0,0,1-.749,1.61",
    transform: "translate(-71.74 -26.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M208,98.674a.971.971,0,0,1-.518-.149L197.154,92.07a.98.98,0,1,1,1.038-1.662l10.328,6.455a.98.98,0,0,1-.52,1.811",
    transform: "translate(-68.215 -31.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M202.3,110.037a.99.99,0,0,1-.229-.027l-13.094-3.135a.98.98,0,1,1,.456-1.906l13.094,3.135a.98.98,0,0,1-.227,1.933",
    transform: "translate(-65.277 -36.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M198.726,124.3h-.057l-12.91-.738a.98.98,0,0,1,.112-1.956l12.91.737a.98.98,0,0,1-.055,1.958",
    transform: "translate(-64.102 -42.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M183.555,139.457a.98.98,0,0,1-.026-1.96l13.463-.368a.98.98,0,1,1,.054,1.959l-13.463.369h-.027",
    transform: "translate(-63.319 -47.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M186.1,154.908a.98.98,0,0,1-.306-1.911l12.91-4.242a.98.98,0,0,1,.611,1.862l-12.91,4.242a.984.984,0,0,1-.306.049",
    transform: "translate(-64.2 -51.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M191.463,169.066a.98.98,0,0,1-.491-1.828l11.8-6.824a.98.98,0,1,1,.98,1.7l-11.8,6.823a.975.975,0,0,1-.49.132",
    transform: "translate(-66.061 -55.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M201.063,183.225a.979.979,0,0,1-.673-1.692l9.959-9.406a.98.98,0,0,1,1.346,1.424l-9.959,9.406a.975.975,0,0,1-.672.268",
    transform: "translate(-69.39 -59.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M215.743,191.672a.98.98,0,0,1-.828-1.5l6.64-10.512a.98.98,0,0,1,1.657,1.046l-6.639,10.512a.979.979,0,0,1-.83.457",
    transform: "translate(-74.482 -62.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M234.1,197.026a.979.979,0,0,1-.973-1.109l1.476-11.066a.98.98,0,0,1,1.943.259l-1.476,11.066a.98.98,0,0,1-.97.85",
    transform: "translate(-80.847 -63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M26.582,97.124l27.3,38.73H1.5Z",
    transform: "translate(-0.52 -33.683)",
    fill: "#45783c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M53.358,136.313H.98A.98.98,0,0,1,.157,134.8L25.239,96.07a.981.981,0,0,1,.8-.447.936.936,0,0,1,.82.415l27.3,38.731a.98.98,0,0,1-.8,1.544m-50.577-1.96H51.469l-25.373-36Z",
    transform: "translate(0 -33.162)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 12.172,
    height: 10.162,
    transform: "translate(21.082 102.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M43.929,167.294H31.756a.98.98,0,0,1-.98-.98V156.153a.98.98,0,0,1,.98-.98H43.929a.98.98,0,0,1,.98.98v10.162a.98.98,0,0,1-.98.98m-11.193-1.96H42.948v-8.2H32.736Z",
    transform: "translate(-10.673 -53.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M31.473,83.993s5.963-6.086,22.87-6.455c14.754,0,25.636,14.2,25.636,34.673,0,16.107-7.992,31.476-26.066,32.644-15.677,0-20.041-3.689-24.56-6.086-2.582-2.152-6.179,6.024-2,10.2,11.465,7.677,64.243,19.857,66.641-36.026,0-40.205-33.812-58.894-66.856-38.361-3.6,2.951,1.291,11.711,4.334,9.406",
    transform: "translate(-8.823 -22.95)",
    fill: "#ece452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M54.054,156.139c-12.2,0-23.445-3.992-27.765-6.884a.981.981,0,0,1-.148-.122,7.915,7.915,0,0,1-2.192-6.043,8.421,8.421,0,0,1,1.858-5.116,2.535,2.535,0,0,1,3.564-.56c.523.28,1.045.575,1.583.881,3.965,2.249,8.9,5.048,22.437,5.048,18.5-1.2,25.087-17.806,25.087-31.664,0-19.523-10.369-33.693-24.656-33.693-16.188.353-22.115,6.106-22.173,6.164a1,1,0,0,1-.1.092c-1.525,1.154-3.482.59-5.11-1.473-1.973-2.5-3.223-7.186-.438-9.472a1.166,1.166,0,0,1,.1-.074c16-9.944,32.972-11.317,46.553-3.766,13.854,7.7,21.8,23.36,21.8,42.96-.841,19.63-7.8,32.873-20.691,39.4a43.531,43.531,0,0,1-19.709,4.32M27.461,147.68c6.484,4.274,28.52,10.951,45.416,2.39,12.21-6.186,18.811-18.869,19.619-37.7,0-18.825-7.58-33.859-20.793-41.2C58.778,63.982,42.559,65.324,27.2,74.849c-1.662,1.438-.677,4.859.778,6.705.238.3,1.455,1.756,2.346,1.154C31.062,82,37.43,76.382,53.8,76.025c15.443,0,26.637,14.994,26.637,35.653,0,14.705-7.067,32.335-26.983,33.622H53.44c-14.107,0-19.287-2.939-23.452-5.3-.549-.312-1.082-.614-1.616-.9a.974.974,0,0,1-.169-.113c-.132-.11-.38-.318-.95.306-1.365,1.5-2.3,5.788.206,8.386m3.492-64.221h0Z",
    transform: "translate(-8.303 -22.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M70.58,78.144a.992.992,0,0,1-.2-.02.981.981,0,0,1-.762-1.158l2.4-11.619a.98.98,0,1,1,1.92.4l-2.4,11.619a.981.981,0,0,1-.959.782",
    transform: "translate(-24.137 -22.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M82.155,80.99a.98.98,0,0,1-.884-1.4L86.25,69.078a.98.98,0,1,1,1.771.839l-4.98,10.512a.979.979,0,0,1-.886.56",
    transform: "translate(-28.152 -23.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M93.732,87.887a.98.98,0,0,1-.75-1.61l7.746-9.222a.98.98,0,0,1,1.5,1.261l-7.746,9.222a.978.978,0,0,1-.751.349",
    transform: "translate(-32.167 -26.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M99.945,98.674a.98.98,0,0,1-.52-1.811l10.328-6.455a.98.98,0,0,1,1.039,1.662l-10.328,6.455a.977.977,0,0,1-.518.149",
    transform: "translate(-34.322 -31.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M104.178,110.037a.98.98,0,0,1-.227-1.933l13.095-3.135a.98.98,0,0,1,.456,1.906l-13.094,3.135a.991.991,0,0,1-.229.027",
    transform: "translate(-35.79 -36.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M107.849,124.3a.98.98,0,0,1-.055-1.958l12.91-.737a.98.98,0,0,1,.112,1.956l-12.91.738h-.057",
    transform: "translate(-37.064 -42.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M122.726,139.457H122.7l-13.464-.369a.98.98,0,0,1,.054-1.959l13.464.368a.98.98,0,0,1-.026,1.96",
    transform: "translate(-37.553 -47.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M120.478,154.908a.984.984,0,0,1-.306-.049l-12.91-4.242a.98.98,0,0,1,.611-1.862L120.784,153a.98.98,0,0,1-.306,1.911",
    transform: "translate(-36.965 -51.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M115.7,169.066a.975.975,0,0,1-.49-.132l-11.8-6.823a.98.98,0,1,1,.981-1.7l11.8,6.824a.98.98,0,0,1-.491,1.828",
    transform: "translate(-35.692 -55.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M107.079,183.225a.975.975,0,0,1-.672-.268l-9.959-9.406a.979.979,0,1,1,1.345-1.424l9.959,9.406a.979.979,0,0,1-.673,1.692",
    transform: "translate(-33.342 -59.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M94.161,191.672a.979.979,0,0,1-.83-.457L86.693,180.7a.98.98,0,1,1,1.657-1.046l6.64,10.512a.98.98,0,0,1-.828,1.5",
    transform: "translate(-30.013 -62.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M78.548,197.026a.98.98,0,0,1-.97-.85L76.1,185.11a.98.98,0,0,1,1.943-.259l1.476,11.066a.979.979,0,0,1-.973,1.109",
    transform: "translate(-26.39 -63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M141.158,59.1v94.428c0,2.891,2.824,4.683,6.393,5.42V59.1Z",
    transform: "translate(-48.955 -20.496)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M147.032,159.407a1.021,1.021,0,0,1-.2-.02c-4.56-.942-7.175-3.267-7.175-6.38V58.58a.979.979,0,0,1,.98-.98h6.394a.98.98,0,0,1,.98.98v99.848a.98.98,0,0,1-.98.98M141.618,59.56v93.448c0,2.407,2.561,3.608,4.435,4.165V59.56Z",
    transform: "translate(-48.434 -19.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M167.935,153.529V59.1H158.1v100.22c5.013-.176,9.836-2.13,9.836-5.792",
    transform: "translate(-54.83 -20.497)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M157.58,159.78a.98.98,0,0,1-.98-.98V58.58a.979.979,0,0,1,.98-.98h9.836a.98.98,0,0,1,.98.98v94.428c0,4.417-5.415,6.584-10.782,6.771h-.034m.98-100.22v98.2c3.964-.344,7.877-1.9,7.877-4.751V59.56Z",
    transform: "translate(-54.31 -19.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M150.947,59.1v99.848a19.891,19.891,0,0,0,4.672.372V59.1Z",
    transform: "translate(-52.35 -20.496)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M154.363,159.793a20.73,20.73,0,0,1-4.134-.4.98.98,0,0,1-.782-.96V58.58a.98.98,0,0,1,.98-.98H155.1a.98.98,0,0,1,.98.98V158.8a.98.98,0,0,1-.945.979q-.386.014-.771.014m-2.956-2.183a19.159,19.159,0,0,0,2.713.222V59.56h-2.713Z",
    transform: "translate(-51.829 -19.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M35.449,1.5c52.374,11.4,104.067,12.2,154.922,0l8.115,9.345c-55.25,15.819-112.558,14.345-171.4,0Z",
    transform: "translate(-9.394 -0.521)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M115.662,22.623c-.685,0-1.369,0-2.056-.006-27.78-.18-57.143-3.995-87.271-11.34a.98.98,0,0,1-.5-1.6L34.2.327a.977.977,0,0,1,.939-.3c53.753,11.7,105.728,11.705,154.484,0a.979.979,0,0,1,.968.311L198.7,9.682a.98.98,0,0,1-.47,1.585,299.829,299.829,0,0,1-82.573,11.356M28.39,9.758c29.422,7.058,58.09,10.725,85.229,10.9A298.359,298.359,0,0,0,196.214,9.8L189.5,2.071C140.789,13.663,88.914,13.66,35.279,2.059Z",
    transform: "translate(-8.874 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M36.388,18v4.426c54.535,12.492,107.734,13.751,159.175.246V18.246C144.122,31.751,90.923,30.492,36.388,18",
    transform: "translate(-12.62 -6.243)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M118.872,32.766q-1.132,0-2.263-.008a376.056,376.056,0,0,1-80.959-9.9.979.979,0,0,1-.761-.955V17.48a.98.98,0,0,1,1.2-.955,374.137,374.137,0,0,0,80.536,9.847,299.675,299.675,0,0,0,78.172-9.593.979.979,0,0,1,1.228.948v4.426a.979.979,0,0,1-.731.948,301.029,301.029,0,0,1-76.42,9.666M36.848,21.125A373.637,373.637,0,0,0,116.623,30.8a299.706,299.706,0,0,0,77.44-9.4v-2.4a301.786,301.786,0,0,1-77.454,9.338,375.293,375.293,0,0,1-79.761-9.623Z",
    transform: "translate(-12.099 -5.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M43.276,26.511v4.3c51.229,11.166,101.265,12.31,149.757.488v-4.1c-48,11.363-98.167,10.428-149.757-.681",
    transform: "translate(-15.008 -9.194)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M121.315,40.082a369.851,369.851,0,0,1-78.768-8.838.979.979,0,0,1-.771-.958v-4.3a.98.98,0,0,1,1.186-.958c52.892,11.39,103.133,11.62,149.325.686a.979.979,0,0,1,1.206.954v4.1a.98.98,0,0,1-.748.952,300.93,300.93,0,0,1-71.43,8.356M43.736,29.5C96.184,40.826,145.9,41,191.533,30v-2.1c-45.8,10.633-95.514,10.4-147.8-.706Z",
    transform: "translate(-14.488 -8.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M63.229,36.968V41.3c42.022,7.776,83.216,8.588,123.384.784V37.892c-39.845,7.5-81.111,6.8-123.384-.924",
    transform: "translate(-21.928 -12.821)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M128.263,47.969A361.263,361.263,0,0,1,62.53,41.74a.98.98,0,0,1-.8-.963V36.447a.981.981,0,0,1,1.156-.964c43.094,7.87,84.486,8.181,123.027.926a.979.979,0,0,1,1.161.963V41.56a.98.98,0,0,1-.793.962,303.927,303.927,0,0,1-58.017,5.448M63.689,39.96c42.6,7.793,83.44,8.058,121.425.79v-2.2c-38.1,7.015-78.94,6.7-121.425-.931Z",
    transform: "translate(-21.408 -12.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M92.876,49.308v3.135h87.789v-3.32c-26.881,3.939-56.514,3.4-87.789.184",
    transform: "translate(-32.21 -17.037)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M180.145,52.9H92.356a.979.979,0,0,1-.98-.98V48.788a.982.982,0,0,1,.323-.728.97.97,0,0,1,.756-.247c34.146,3.508,62.783,3.45,87.547-.179a.979.979,0,0,1,1.122.969v3.32a.979.979,0,0,1-.98.98m-11.028-1.96h10.049V49.735q-4.922.7-10.049,1.209m-75.781,0h11.87q-5.824-.461-11.87-1.071Z",
    transform: "translate(-31.69 -16.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M145.132,57.986c-8.115,0-15.739-1.275-20.4-3.409a.98.98,0,0,1,.408-1.871h39.974a.98.98,0,0,1,.408,1.871c-4.656,2.134-12.281,3.409-20.4,3.409m-13.7-3.32a65.06,65.06,0,0,0,13.7,1.361,65.059,65.059,0,0,0,13.7-1.361Z",
    transform: "translate(-43.061 -18.279)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 21.21,
    height: 10.697,
    transform: "translate(91.65 6.636)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M161,21.316H139.792a.98.98,0,0,1-.98-.98V9.639a.98.98,0,0,1,.98-.98H161a.98.98,0,0,1,.98.98v10.7a.98.98,0,0,1-.98.98m-20.229-1.96h19.25V10.619h-19.25Z",
    transform: "translate(-48.141 -3.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M161.411,6.9c0,1.63-4.913,2.951-10.974,2.951S139.464,8.528,139.464,6.9s4.913-2.951,10.974-2.951S161.411,5.268,161.411,6.9",
    transform: "translate(-48.367 -1.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M149.917,10.309c-4.44,0-11.953-.828-11.953-3.93s7.514-3.931,11.953-3.931,11.953.828,11.953,3.931-7.514,3.93-11.953,3.93m-9.978-3.93c.415.713,4.071,1.971,9.978,1.971s9.563-1.258,9.978-1.971c-.415-.713-4.071-1.971-9.978-1.971s-9.563,1.258-9.978,1.971m19.979.044h0Z",
    transform: "translate(-47.847 -0.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M27.088,10.845l.154-.172L35.449,1.5l9.345,2.152-7.377,9.775Z",
    transform: "translate(-9.394 -0.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M36.9,13.887a.983.983,0,0,1-.238-.029L26.33,11.276a.98.98,0,0,1-.493-1.6L34.2.328a.982.982,0,0,1,.95-.3l9.345,2.152a.98.98,0,0,1,.562,1.545L37.678,13.5a.981.981,0,0,1-.782.39M28.38,9.768,36.5,11.8l6.076-8.051L35.273,2.066Z",
    transform: "translate(-8.874 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M262.288,3.837l6.455,9.59,11.312-2.582L271.939,1.5Z",
    transform: "translate(-90.963 -0.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M268.223,13.886a.979.979,0,0,1-.813-.432l-6.455-9.59a.979.979,0,0,1,.582-1.5L271.189.028a.977.977,0,0,1,.97.31l8.115,9.345a.98.98,0,0,1-.522,1.6l-11.311,2.582a.992.992,0,0,1-.218.024m-4.856-9.949L268.66,11.8l9.063-2.069L271.07,2.073Z",
    transform: "translate(-90.443 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M71.417,34.128S94.84,16.423,101.848,14.394c0,0-7.93,11.435-30.431,19.734",
    transform: "translate(-24.768 -4.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M138.053,39.443s36.483-23.993,47.4-26.742c0,0-12.353,15.5-47.4,26.742",
    transform: "translate(-47.878 -4.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M38.3,263.558l2.446.775a5.486,5.486,0,0,1-1.87,3.038,5.334,5.334,0,0,1-3.32.993,5.378,5.378,0,0,1-4.091-1.7,6.506,6.506,0,0,1-1.6-4.649,6.827,6.827,0,0,1,1.611-4.845,5.519,5.519,0,0,1,4.235-1.726,5.2,5.2,0,0,1,3.724,1.355,4.934,4.934,0,0,1,1.278,2.3l-2.5.6a2.578,2.578,0,0,0-2.633-2.1,2.842,2.842,0,0,0-2.254,1,4.884,4.884,0,0,0-.865,3.23,5.238,5.238,0,0,0,.852,3.374,2.767,2.767,0,0,0,2.216,1.006,2.527,2.527,0,0,0,1.73-.639,3.715,3.715,0,0,0,1.04-2.011",
    transform: "translate(-10.357 -88.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M57.072,261.981a7.941,7.941,0,0,1,.571-3.2,5.859,5.859,0,0,1,1.163-1.713,4.866,4.866,0,0,1,1.614-1.125,6.869,6.869,0,0,1,2.694-.494,5.864,5.864,0,0,1,4.418,1.713,7.656,7.656,0,0,1,.013,9.5,5.821,5.821,0,0,1-4.4,1.709,5.883,5.883,0,0,1-4.431-1.7,6.452,6.452,0,0,1-1.644-4.683m2.6-.085a4.681,4.681,0,0,0,.98,3.217,3.368,3.368,0,0,0,4.964.008,4.772,4.772,0,0,0,.967-3.259,4.7,4.7,0,0,0-.941-3.2,3.49,3.49,0,0,0-5.015.013,4.717,4.717,0,0,0-.954,3.226",
    transform: "translate(-19.793 -88.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M88.99,268.264v-10.38H85.283v-2.113h9.928v2.113h-3.7v10.38Z",
    transform: "translate(-29.577 -88.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M111,268.264V255.771h5.309a9.1,9.1,0,0,1,2.91.336,2.872,2.872,0,0,1,1.453,1.2,3.6,3.6,0,0,1,.545,1.968,3.336,3.336,0,0,1-.826,2.323,3.969,3.969,0,0,1-2.472,1.155,5.888,5.888,0,0,1,1.351,1.048,14.222,14.222,0,0,1,1.436,2.029l1.526,2.437h-3.016l-1.824-2.719a17.761,17.761,0,0,0-1.329-1.837,1.949,1.949,0,0,0-.758-.519,4.159,4.159,0,0,0-1.27-.14h-.511v5.215Zm2.522-7.209h1.866a9.659,9.659,0,0,0,2.267-.154,1.362,1.362,0,0,0,.707-.528,1.627,1.627,0,0,0,.255-.937,1.5,1.5,0,0,0-.336-1.018,1.54,1.54,0,0,0-.95-.49q-.307-.043-1.841-.043h-1.969Z",
    transform: "translate(-38.497 -88.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M148.893,268.264h-2.744l-1.091-2.838h-4.994l-1.031,2.838h-2.676l4.866-12.493h2.668Zm-4.644-4.943-1.722-4.636-1.687,4.636Z",
    transform: "translate(-47.29 -88.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M165.652,268.264V255.771h2.454l5.113,8.343v-8.343h2.344v12.493h-2.531L168,260.117v8.147Z",
    transform: "translate(-57.45 -88.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M191.946,264.085l2.454-.238a2.993,2.993,0,0,0,.9,1.815,2.715,2.715,0,0,0,1.828.579,2.809,2.809,0,0,0,1.836-.515,1.534,1.534,0,0,0,.618-1.206,1.135,1.135,0,0,0-.26-.754,2.068,2.068,0,0,0-.907-.541q-.444-.154-2.02-.545a6.86,6.86,0,0,1-2.847-1.236,3.252,3.252,0,0,1-1.15-2.514,3.208,3.208,0,0,1,.542-1.785,3.374,3.374,0,0,1,1.559-1.265,6.244,6.244,0,0,1,2.459-.435,5.275,5.275,0,0,1,3.541,1.031,3.639,3.639,0,0,1,1.248,2.752l-2.522.111a2.149,2.149,0,0,0-.7-1.385,2.546,2.546,0,0,0-1.6-.421,2.883,2.883,0,0,0-1.722.451.912.912,0,0,0-.4.775.96.96,0,0,0,.375.759,6.636,6.636,0,0,0,2.318.835,12.2,12.2,0,0,1,2.723.9,3.516,3.516,0,0,1,1.381,1.27,3.933,3.933,0,0,1-.1,4,3.574,3.574,0,0,1-1.687,1.393,7.07,7.07,0,0,1-2.719.456,5.411,5.411,0,0,1-3.639-1.095,4.758,4.758,0,0,1-1.517-3.191",
    transform: "translate(-66.568 -88.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M226.52,263.558l2.446.775a5.486,5.486,0,0,1-1.87,3.038,5.887,5.887,0,0,1-7.41-.707,6.506,6.506,0,0,1-1.6-4.649,6.827,6.827,0,0,1,1.611-4.845,5.519,5.519,0,0,1,4.235-1.726,5.2,5.2,0,0,1,3.724,1.355,4.935,4.935,0,0,1,1.278,2.3l-2.5.6a2.578,2.578,0,0,0-2.633-2.1,2.842,2.842,0,0,0-2.254,1,4.884,4.884,0,0,0-.865,3.23,5.238,5.238,0,0,0,.852,3.374,2.767,2.767,0,0,0,2.216,1.006,2.527,2.527,0,0,0,1.73-.639,3.715,3.715,0,0,0,1.04-2.011",
    transform: "translate(-75.633 -88.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M256.664,268.264H253.92l-1.091-2.838h-4.994l-1.031,2.838h-2.676l4.866-12.493h2.668Zm-4.644-4.943-1.722-4.636-1.687,4.636Z",
    transform: "translate(-84.666 -88.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M273.738,268.264v-10.38h-3.707v-2.113h9.928v2.113h-3.7v10.38Z",
    transform: "translate(-93.649 -88.703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoVertical);
export default __webpack_public_path__ + "static/media/icon_logo_vertical.6e73a21c56a3e47af480e1dff417160d.svg";
export { ForwardRef as ReactComponent };